import { Component } from '@angular/core';
import { PlatformIdmService } from '@platform-idm/sdk-angular';
import { IdmUtilities } from '@platform-idm/sdk-javascript';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
    styleUrl: './logout.component.scss',
    standalone: false
})
export class LogoutComponent {
  constructor(private auth: PlatformIdmService) {
    //delete any other browser state needed, like cookies and storage
    //this will remove library state and call service logout


    var utility = new IdmUtilities();
    var afterSaveRedirect = utility.readCookie("mx1.afterSaveRedirect") || "/secured";
    utility.deleteCookie("mx1.afterSaveRedirect");

    this.auth.authentication.logout(afterSaveRedirect);
  }
}
